import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Navbar } from './Navbar';
import { Sidebar } from './Sidebar';

interface MainLayoutProps {
  user?: {
    email: string;
    plan: string;
  } | null;
  onLogout?: () => void;
}

export const MainLayout: React.FC<MainLayoutProps> = ({ user, onLogout }) => {
  const [sidebarOpen, setSidebarOpen] = useState(true);

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar
        user={user}
        onLogout={onLogout}
        onMenuClick={() => setSidebarOpen(true)}
      />

      <div className="flex h-[calc(100vh-4rem)]">
        {/* Sidebar - Always visible on desktop, toggleable on mobile */}
        <Sidebar
          isOpen={sidebarOpen}
          onClose={() => setSidebarOpen(false)}
        />

        {/* Main content - Add left padding on desktop to account for sidebar */}
        <main className="flex-1 overflow-y-auto w-full lg:w-auto">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};
